module.exports = __webpack_public_path__ + "static/media/luggages2.82da006d.jpg";